export default __webpack_public_path__ + "static/media/bottom.280f3bf5.png";